import { Theme } from '@mui/material/styles';

type TypographyOptions = Theme['typography'];

export const typography: TypographyOptions = {
    fontFamily: "'Inter', sans-serif",
    fontSize: 14,
    htmlFontSize: 16,
    pxToRem: (size: number) => `${size / 16}rem`,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 700,
    display1: {
        fontFamily: "'Sentient', serif",
        fontSize: "clamp(3.5rem, 9vw, 6.5rem)",
        fontWeight: 500,
        lineHeight: 1.05,
        letterSpacing: "-0.01em",
    },
    display2: {
        fontFamily: "'Sentient', serif",
        fontSize: "clamp(2.8rem, 6vw, 4.5rem)",
        fontWeight: 500,
        lineHeight: 1.1,
        letterSpacing: "-0.01em",
    },
    h1: {
        fontFamily: "'Sentient', serif",
        fontSize: "clamp(2rem, 4vw, 2.8rem)",
        fontWeight: 500,
        lineHeight: "120%",
    },
    h2: {
        fontFamily: "'Sentient', serif",
        fontSize: "clamp(1.75rem, 3.5vw, 2.2rem)",
        fontWeight: 500,
        lineHeight: "120%",
    },
    h3: {
        fontFamily: "'Sentient', serif",
        fontSize: "clamp(1.5rem, 3vw, 1.9rem)",
        fontWeight: 500,
        lineHeight: "120%",
    },
    h4: {
        fontFamily: "'Sentient', serif",
        fontSize: "clamp(1.25rem, 2.5vw, 1.5rem)",
        fontWeight: 400,
        lineHeight: "150%",
    },
    h5: {
        fontFamily: "'Sentient', serif",
        fontSize: "clamp(1.1rem, 2vw, 1.25rem)",
        fontWeight: 400,
        lineHeight: 1.4,
    },
    h6: {
        fontFamily: "'Sentient', serif",
        fontSize: "clamp(1rem, 1.75vw, 1.1rem)",
        fontWeight: 400,
        lineHeight: 1.4,
    },
    subtitle1: {
        fontSize: "1rem",
        fontWeight: 500,
        lineHeight: 1.5,
    },
    subtitle2: {
        fontSize: "clamp(0.75rem, 1.25vw, 0.8rem)",
        fontWeight: 600,
        color: "#b47c52",
        textTransform: "uppercase" as const,
        letterSpacing: "0.1em",
        lineHeight: "180%",
    },
    body1: {
        fontSize: "0.95rem",
        fontWeight: 400,
        lineHeight: "180%",
    },
    body2: {
        fontSize: "clamp(0.875rem, 1.5vw, 0.95rem)",
        lineHeight: "180%",
    },
    button: {
        fontSize: "0.8rem",
        fontWeight: 600,
        lineHeight: 1.2,
        letterSpacing: "0.06em",
        textTransform: "uppercase" as const,
    },
    caption: {
        fontSize: "0.875rem",
        lineHeight: "180%",
    },
    overline: {
        color: "#b47c52",
        letterSpacing: "0.15em",
        opacity: 0.9,
        fontWeight: 700,
        lineHeight: "180%",
        textTransform: "uppercase" as const,
        fontSize: "0.75rem",
    },
    technical: {
        fontFamily: "'Fira Code', monospace",
        fontSize: "0.75rem",
        fontWeight: 500,
        letterSpacing: "0.05em",
        textTransform: "uppercase" as const,
        lineHeight: 1.5,
    },
};
